import React, { useEffect, useRef, useState } from 'react';
import MicIcon from '@mui/icons-material/Mic';
import MicOffIcon from '@mui/icons-material/MicOff';
import ScreenShareIcon from '@mui/icons-material/ScreenShare';
import StopScreenShareIcon from '@mui/icons-material/StopScreenShare';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import VideocamIcon from '@mui/icons-material/Videocam';
import VideocamOffIcon from '@mui/icons-material/VideocamOff';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import NotificationAlert from 'react-notification-alert';
import PanToolIcon from '@mui/icons-material/PanTool';
import './meeting-screen.css';
import { Progress } from 'reactstrap';
import { db } from 'MY_LOGIN_AND_SIGNUP/db/config';

import AdjustIcon from '@mui/icons-material/Adjust';

import MeetingVideoComponent from '../VideoComponent/VideoComponent';

import firebase from 'firebase';
import MeetingDuration from '../MeetingDuration/MeetingDuration';
import { useOnlineStatus, useBeforeUnload } from 'Utilities/customHooks';
import { useLocation, useNavigate } from 'react-router-dom';
import { useWbex } from 'Utilities/customHooks';
import AudioComponent from '../AudioComponent/AudioComponent';

const MeetingScreen = ({ webex, meeting }) => {
  const notifi = useRef();
  const notify = (msg, err) => {
    // console.log('notify')
    let color = err == false ? 'success' : 'danger';
    let options = {
      type: color,
      place: 'tr',
      message: (
        <div>
          <div>
            <b>{err == false ? 'Success' : 'Error'}</b> - {msg}.
          </div>
        </div>
      ),
      icon: 'tim-icons icon-bell-55',
      autoDismiss: 6,
    };
    if (notifi.current) {
      notifi.current.notificationAlert(options);
    }
    // notification(options);
  };

  const [startedSharingRemote, setStartedSharingRemote] = useState(false);
  const [currentActiveSpeakersMemberIds, setCurrentActiveSpeakersMemberIds] =
    useState([]);
  const [memberVideos, setMemberVideos] = useState([]);
  const [isMuted, setIsMuted] = useState(false);
  const [muteVideo, setMuteVideo] = useState(false);

  const [networkDeactivated, setNetworkDeactivated] = useState(false);
  const [muteAll, setMuteAll] = useState(true);

  const [alreadyJoined, setAlreadyJoined] = useState(false);

  const [isScreenSharing, setIsScreenSharing] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [pauseRecording, setPauseRecording] = useState(false);

  const [screenShareStream, setScreenShareStream] = useState(null);
  const [meetingDuration, setMeetingDuration] = useState(0);
  const [allVideoPanes, setAllVideoPanes] = useState({});
  const [remoteAudios, setRemoteAudios] = useState([]);

  const [membersInMeet, setMembersInMeet] = useState([]);
  const [selfMemeber, setSelfMemeber] = useState({});

  const [meetingActualStartTime, setMeetingActualStartTime] = useState(0);

  const [isModerator, setIsModerator] = useState(false);

  const [isInitializing, setIsInitializing] = useState(false);

  const [allRemoteVideos, setAllRemoteVideos] = useState([]);

  const location = useLocation();
  const navigate = useNavigate();

  const { hostKey, ongoingclassName, apiMeetingId } = location.state || {};

  const isOnline = useOnlineStatus();

  const [
    meetingsWithMultistreamListeners,
    setMeetingsWithMultistreamListeners,
  ] = useState({});

  const [remoteSourcesCount, setRemoteSourcesCount] = useState({
    audio: {
      total: 0,
      live: 0,
    },
    video: {
      total: 0,
      live: 0,
    },
  });

  const localVideoQuality = {
    '360p': '360p',
    '480p': '480p',
    '720p': '720p',
    '1080p': '1080p',
  };
  const [localMedia, setLocalMedia] = useState({
    microphoneStream: undefined,
    cameraStream: undefined,
    screenShare: {
      video: undefined,
      audio: undefined,
    },
    videoConstraints: {
      [localVideoQuality['360p']]: { width: 640, height: 360 },
      [localVideoQuality['480p']]: { width: 640, height: 480 },
      [localVideoQuality['720p']]: { width: 1280, height: 720 },
      [localVideoQuality['1080p']]: { width: 1920, height: 1080 },
    },
  });

  const localVideoRef = useRef(null);
  const localAudioRef = useRef(null);
  const screenShareVideoRef = useRef(null);
  const screenShareAudioRef = useRef(null);

  async function loadMicrophone(constraints) {
    try {
      console.log(
        'MeetingControls#loadMicrophone() :: using webrtc-core local microphone stream'
      );
      const audioConstraints = { ...constraints };

      console.log(
        'MeetingControls#loadMicrophone() :: getting microphone stream with constraints: ',
        audioConstraints
      );
      localMedia.microphoneStream =
        await webex.meetings.mediaHelpers.createMicrophoneStream(
          audioConstraints
        );

      // if (isOnline) {
      //   localAudioRef.current.srcObject =
      //     localMedia.microphoneStream.outputStream;
      // }

      localMedia.microphoneStream.on('user-mute-state-change', (muted) => {
        console.log(
          'MeetingControls#loadMicrophone() :: local microphone stream user mute state changed to',
          muted
        );
        // handleAudioButton();
      });

      localMedia.microphoneStream.on('system-mute-state-change', (muted) => {
        console.log(
          'MeetingControls#loadMicrophone() :: local microphone stream system mute state changed to',
          muted
        );
        // handleMuteAudioMessage();
      });

      localMedia.microphoneStream.on('stream-ended', () => {
        console.log(
          'MeetingControls#loadMicrophone() :: local microphone stream ended'
        );

        localMedia.microphoneStream = undefined;
      });

      console.log(
        'MeetingControls#loadMicrophone() :: Successfully got microphone stream:',
        localMedia.microphoneStream
      );
    } catch (e) {
      console.log(
        'MeetingControls#loadMicrophone() :: Error getting microphone stream!'
      );
      throw e;
    }
  }

  async function loadCamera(constraints) {
    try {
      console.log(
        'MeetingControls#loadCamera() :: using webrtc-core local camera stream'
      );
      const videoConstraints = {
        ...localMedia.videoConstraints[localVideoQuality['720p']],
        ...constraints,
      };

      console.log(
        'MeetingControls#loadCamera() :: getting camera stream with constraints: ',
        videoConstraints
      );
      localMedia.cameraStream =
        await webex.meetings.mediaHelpers.createCameraStream(videoConstraints);

      if (isOnline) {
        // localVideoRef.current.srcObject = localMedia.cameraStream.outputStream;
      }

      localMedia.cameraStream.on('user-mute-state-change', (muted) => {
        console.log(
          'MeetingControls#loadCamera() :: local camera stream user mute state changed to',
          muted
        );
      });

      localMedia.cameraStream.on('system-mute-state-change', (muted) => {
        console.log(
          'MeetingControls#loadCamera() :: local camera stream system mute state changed to',
          muted
        );
        // handleMuteVideoMessage();
      });

      localMedia.cameraStream.on('stream-ended', () => {
        console.log(
          'MeetingControls#loadCamera() :: local camera stream ended'
        );

        localMedia.cameraStream = undefined;
      });

      console.log(
        'MeetingControls#loadCamera() :: Successfully got camera stream:',
        localMedia.cameraStream
      );
    } catch (e) {
      console.log(
        'MeetingControls#loadCamera() :: Error getting camera stream!'
      );
      throw e;
    }
  }

  console.log(webex, meeting, 'webex');

  const muteParticipant = (participantID, newMuteStatus) => {
    try {
      if (meeting) {
        meeting
          .mute(participantID, newMuteStatus)
          .then((res) => {
            console.log(
              res,
              `participant is ${newMuteStatus ? 'muted' : 'unmuted'}`
            );
          })
          .catch((err) => {
            console.log('error', err);
          });
      }
    } catch (error) {
      console.log(error);
    }
  };

  async function getUserMedia(constraints = { audio: true, video: true }) {
    try {
      // const meeting = getCurrentMeeting();

      // console.log('MeetingControls#getUserMedia()');

      if (!meeting) {
        console.log(
          'MeetingControls#getUserMedia() :: no valid meeting object!'
        );

        throw new Error('No valid meeting object.');
      }

      if (localMedia.microphoneStream) {
        console.log(
          'MeetingControls#getUserMedia() :: microphone stream is already available'
        );
      } else if (constraints.audio) {
        await loadMicrophone(constraints);
      }

      if (localMedia.cameraStream) {
        console.log(
          'MeetingControls#getUserMedia() :: camera stream is already available'
        );
      } else if (constraints.video) {
        await loadCamera(constraints.video);
      }

      console.log(
        'MeetingControls#getUserMedia() :: following local streams are ready to use:',
        localMedia.microphoneStream,
        localMedia.cameraStream
      );
      setLocalMedia(localMedia);
    } catch (error) {
      console.log(error);
    }
  }
  console.log(localMedia, 'localMedia');
  async function stopMicrophone() {
    try {
      console.log(
        'MeetingControls#stopMicrophone() :: stopping microphone stream'
      );

      if (localMedia.microphoneStream) {
        // Stop the microphone stream
        await localMedia.microphoneStream.stop();

        // Clear the audio element's source
        // if (localAudioRef.current) {
        //   localAudioRef.current.srcObject = null;
        // }

        // Clear the reference
        localMedia.microphoneStream = undefined;

        console.log(
          'MeetingControls#stopMicrophone() :: microphone stream stopped successfully'
        );
      } else {
        console.log(
          'MeetingControls#stopMicrophone() :: no microphone stream to stop'
        );
      }
    } catch (e) {
      console.log(
        'MeetingControls#stopMicrophone() :: Error stopping microphone stream!',
        e
      );
    }
  }

  async function stopCamera() {
    try {
      console.log('MeetingControls#stopCamera() :: stopping camera stream');

      if (localMedia.cameraStream) {
        // Stop the camera stream
        await localMedia.cameraStream.stop();

        // Clear the video element's source
        // if (localVideoRef.current) {
        //   localVideoRef.current.srcObject = null;
        // }

        // Clear the reference
        localMedia.cameraStream = undefined;

        console.log(
          'MeetingControls#stopCamera() :: camera stream stopped successfully'
        );
      } else {
        console.log('MeetingControls#stopCamera() :: no camera stream to stop');
      }
    } catch (e) {
      console.log(
        'MeetingControls#stopCamera() :: Error stopping camera stream!',
        e
      );
    }
  }

  async function stopUserMedia() {
    try {
      console.log('MeetingControls#stopUserMedia()');

      // Stop microphone if it exists
      if (localMedia.microphoneStream) {
        await stopMicrophone();
      }

      // Stop camera if it exists
      if (localMedia.cameraStream) {
        await stopCamera();
      }

      console.log(
        'MeetingControls#stopUserMedia() :: all media streams stopped'
      );
    } catch (error) {
      console.log(error);
    }
  }

  function updateRemoteSourcesInfo() {
    try {
      console.log(
        `Remote live sources: audio=${remoteSourcesCount.audio.live}/${remoteSourcesCount.audio.total} video=${remoteSourcesCount.video.live}/${remoteSourcesCount.video.total}`
      );
    } catch (error) {
      console.log(error);
    }
  }

  function clearAllMultistreamVideoElements() {
    setAllVideoPanes({});
  }

  function getDisplayNameForMemberId(meeting, memberId) {
    try {
      if (memberId) {
        return meeting.members.membersCollection.get(memberId).name;
      }

      return '';
    } catch (error) {
      console.log(error);
    }
  }

  function processNewVideoPane(
    allVideoPanes,
    meeting,
    paneGroupId,
    paneId,
    remoteMedia
  ) {
    try {
      let updatedData = {};

      console.log(remoteMedia, 'remoteMedia');
      if (remoteMedia?.sourceState === 'no source') {
        let memberName = getDisplayNameForMemberId(
          meeting,
          remoteMedia?.memberId
        );
        updatedData = {
          memberId: remoteMedia?.memberId,
          membernamee: memberName,
          debugText: '',
          isActive: true,
          onclick: null,
          onCtrlClick: null,
          remoteMedia: remoteMedia,
        };
      } else if (remoteMedia?.sourceState === 'live') {
        let memberName = getDisplayNameForMemberId(
          meeting,
          remoteMedia?.memberId
        );
        updatedData = {
          memberId: remoteMedia?.memberId,
          membernamee: memberName,
          debugText: '',
          isActive: true,
          onclick: null,
          onCtrlClick: null,
          remoteMedia: remoteMedia,
        };
      } else {
        updatedData = {
          memberId: remoteMedia?.memberId,
          membernamee: '',
          debugText: '',
          isActive: false,
          onclick: null,
          onCtrlClick: null,
          remoteMedia: null,
        };
      }
      return updatedData;
    } catch (error) {
      console.log(error);
    }
  }

  function updateVideoPanesForActiveSpeaker() {
    try {
      Object?.values(allVideoPanes).forEach((paneGroup) =>
        Object.values(paneGroup).forEach((videoPane) => {
          // if (
          //   videoPane.memberId &&
          //   currentActiveSpeakersMemberIds.includes(videoPane.memberId)
          // ) {
          //   videoPane.nameLabelEl.classList.add('speaking');
          // } else {
          //   videoPane.nameLabelEl.classList.remove('speaking');
          // }
        })
      );
    } catch (error) {
      console.log(error);
    }
  }

  function setRemoteStream(memberId) {
    try {
      return allRemoteVideos?.filter(
        (stream) => stream.memberId === memberId
      )[0];
    } catch (error) {
      console.log(error);
    }
  }

  function forceLayoutChange(newLayoutId) {
    try {
      const selectLayoutElm = document.getElementById('multistream-layout');
      selectLayoutElm.value = newLayoutId;
      selectLayoutElm.dispatchEvent(new Event('change'));
    } catch (error) {
      console.log(error);
    }
  }

  function stopForcedScreenShareViewLayout(meeting) {
    if (meeting.remoteMediaManager) {
      if (meeting.remoteMediaManager.getLayoutId() === 'ScreenShareView') {
        const selectLayoutElm = document.getElementById('multistream-layout');

        const newLayout = 'AllEqual';

        forceLayoutChange(newLayout);
      }
    }
  }

  function handleStartRecording() {
    try {
      if (meeting) {
        meeting
          .startRecording()
          .then(() => {
            setIsRecording(true);
          })
          .catch((error) => {
            console.log(
              'MeetingControls#startRecording() :: unable to record meeting.'
            );
            console.error(error);
          });
      } else {
        console.log(
          'MeetingControls#startRecording() :: no valid meeting object!'
        );
      }
    } catch (error) {
      console.log(error);
    }
  }

  function handlePauseRecording() {
    try {
      if (meeting) {
        console.log('MeetingControls#pauseRecording()');

        meeting
          .pauseRecording()
          .then(() => {
            setPauseRecording(true);
          })
          .catch((error) => {
            console.log(
              'MeetingControls#pauseRecording() :: unable to pause recording.'
            );
            console.error(error);
          });
      } else {
        console.log(
          'MeetingControls#pauseRecording() :: no valid meeting object!'
        );
      }
    } catch (error) {
      console.log(error);
    }
  }

  function handleResumeRecording() {
    try {
      if (meeting) {
        meeting
          .resumeRecording()
          .then(() => {
            setPauseRecording(false);
            console.log(
              'MeetingControls#resumeRecording() :: meeting recording resumed!'
            );
          })
          .catch((error) => {
            'Error! See console for details.';
            console.log(
              'MeetingControls#resumeRecording() :: unable to resume recording.'
            );
            console.error(error);
          });
      } else {
        console.log(
          'MeetingControls#resumeRecording() :: no valid meeting object!'
        );
      }
    } catch (error) {
      console.log(error);
    }
  }

  function togglrRecordingPlayPause() {
    if (pauseRecording) {
      handleResumeRecording();
    } else {
      handlePauseRecording();
    }
  }

  function handleStopRecording() {
    try {
      if (meeting) {
        console.log('MeetingControls#stopRecording()');
        meeting
          .stopRecording()
          .then(() => {
            setPauseRecording(false);
            setIsRecording(false);
            console.log(
              'MeetingControls#stopRecording() :: meeting recording stopped!'
            );
          })
          .catch((error) => {
            console.log(
              'MeetingControls#stopRecording() :: unable to stop recording!'
            );
            console.error(error);
          });
      } else {
        console.log(
          'MeetingControls#stopRecording() :: no valid meeting object!'
        );
      }
    } catch (error) {
      console.log(error);
    }
  }

  function setupMultistreamEventListeners() {
    try {
      if (meetingsWithMultistreamListeners[meeting.id]) {
        // listeners already registered
        return;
      }
      if (!meeting) {
        console.log('no meeting available');
        return;
      }

      meeting.on('network:disconnected', () => {
        setNetworkDeactivated(true);
      });

      webex.meetings.on('network:connected', () => {
        if (networkDeactivated) {
          setNetworkDeactivated(false);
          loadCamera();
        }
        //Perform operations to reconnect Meeting
      });
      meeting.on('meeting:reconnectionFailure', () => {
        notify('Failed to reconnect', 'error');
        leaveMeeting();
      });

      meeting.on('meeting:reconnectionSuccess', () => {
        if (networkDeactivated) {
          setNetworkDeactivated(false);
        }
      });
      // meeting.on('meeting:reconnectionSuccess', () => {
      //   console.log('recoonection');

      //   loadCamera();
      // });

      meeting.on('media:remoteAudio:created', (audioMediaGroup) => {
        let audios = audioMediaGroup.getRemoteMedia();
        setRemoteAudios(audios);

        // audioMediaGroup.getRemoteMedia().forEach((media, index) => {
        //   document.getElementsByClassName('multistream-remote-audio')[
        //     index
        //   ].srcObject = media.stream;
        // });
      });

      meeting.on(
        'media:remoteScreenShareAudio:created',
        (screenShareAudioMediaGroup) => {
          let screenShareAudio = screenShareAudioMediaGroup.getRemoteMedia();
          console.log(screenShareAudio, 'screenShareAudio');
        }
      );

      meeting.on(
        'media:remoteVideo:layoutChanged',
        ({ layoutId, screenShareVideo }) => {
          if (screenShareVideo) {
            const stream = screenShareVideo.stream;
            if (stream) {
              setScreenShareStream(stream);
            }
          }
        }
      );

      meeting.on('media:remoteVideoSourceCountChanged', (data) => {
        setRemoteSourcesCount({
          ...remoteSourcesCount,
          video: { total: data.numTotalSources, live: data.numLiveSources },
        });

        updateRemoteSourcesInfo();
      });

      meeting.members.on('members:update', (res) => {
        console.log('member update', meeting, res);
        if (meeting?.meetingState === 'TERMINATING') {
          handleMeetingEnd();
        }
        setAllRemoteVideos(
          meeting?.members?.receiveSlotManager?.allocatedSlots['VIDEO-MAIN']
        );

        Object.values(res?.full)?.map((mem) => {
          if (
            mem.isInMeeting &&
            mem?.isSelf &&
            mem?.isModerator &&
            !isModerator
          ) {
            setIsModerator(true);
          }
          if (
            mem.isInMeeting &&
            mem?.isSelf &&
            !mem?.isModerator &&
            isModerator
          ) {
            setIsModerator(false);
          }
        });
        let membersInMeet = Object.values(res?.full)?.filter((mem) => {
          if (mem.isInMeeting && !mem?.isSelf) {
            return mem;
          }
        });
        let getSelfMember = Object.values(res?.full)?.filter((mem) => {
          if (mem?.isSelf) {
            setIsMuted(mem?.isAudioMuted);
            return mem;
          }
        });

        if (getSelfMember[0]) setSelfMemeber(getSelfMember[0]);
        /* This set timeout creates a delay between stream update and member update,
        when presenter on/off his media multiple time then student side media of presenter is not updating
        */
        setTimeout(() => {
          setMembersInMeet(membersInMeet);
        }, 1000);

        let lobyUsers = Object.values(res?.full)
          ?.filter((mem) => mem.isInLobby)
          ?.map((lobyMem) => lobyMem?.id);

        if (lobyUsers?.length > 0) {
          meeting?.admit(lobyUsers);
        }
        console?.log(res, meeting, membersInMeet, 'allVideoPanes');
      });

      meeting.on('media:remoteAudioSourceCountChanged', (data) => {
        setRemoteSourcesCount({
          ...remoteSourcesCount,
          audio: { total: data.numTotalSources, live: data.numLiveSources },
        });

        updateRemoteSourcesInfo();
      });

      meeting.on('media:activeSpeakerChanged', (data) => {
        setCurrentActiveSpeakersMemberIds(data.memberIds);
        updateVideoPanesForActiveSpeaker();
      });

      meeting.on('meeting:stoppedSharingLocal', (reason) => {
        setIsScreenSharing(false);
      });

      meeting.on('meeting:startedSharingRemote', (event) => {
        setStartedSharingRemote(true);
        if (meeting.remoteMediaManager) {
          meeting.remoteMediaManager.setLayout('ScreenShareView');
        }
      });
      meeting.on('meeting:stoppedSharingRemote', () => {
        setStartedSharingRemote(false);

        setScreenShareStream(null);
        if (meeting.remoteMediaManager) {
          meeting.remoteMediaManager.setLayout('AllEqual');
        }
      });
      let data = JSON.parse(JSON.stringify(meetingsWithMultistreamListeners));
      data[meeting.id] = true;
      setMeetingsWithMultistreamListeners(data);
    } catch (error) {
      console.log(error);
    }
  }

  function doPreMediaSetup() {
    updateRemoteSourcesInfo();
    // setupMultistreamEventListeners();
  }

  function doPostMediaSetup() {
    if (meeting.shareStatus === 'remote_share_active') {
      // forceScreenShareViewLayout(meeting);
    }
  }

  function viewParticipants() {
    try {
      if (meeting) {
        const { members } = meeting.members.membersCollection;
      }
    } catch (error) {
      console.log(error);
    }
  }

  function updatePublishedEvents(event) {
    try {
      // skip network:quality
      if (event === 'network:quality') return;

      const par = document.createElement('p');
      const currTime = new Date();

      let hours = currTime.getHours();
      let minutes = currTime.getMinutes();
      let seconds = currTime.getSeconds();

      if (hours < 10) {
        hours = `0${hours}`;
      }
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }

      par.innerText = `${hours}:${minutes}:${seconds} - ${event}`;
    } catch (error) {
      console.log(error);
    }
  }

  async function joinMeeting(
    { withMedia, withDevice } = { withMedia: false, withDevice: false }
  ) {
    try {
      document.querySelector('#loading-indicator').style.display = 'flex';
      let resourceId = null;

      if (!meeting) {
        console.log('isNotmeeting found ....');
        return;
      }

      const joinOptions = {
        enableMultistream: true,
        pin: hostKey,
        moderator: false,
        breakoutsSupported: false,
        moveToResource: false,
        rejoin: true,
        resourceId,
        locale: 'en_UK', // audio disclaimer language
        deviceCapabilities: [
          'SERVER_AUDIO_ANNOUNCEMENT_SUPPORTED',
          'CONFLUENCE_IN_LOBBY_SUPPORTED',
        ], // audio disclaimer toggle
      };

      // const mediaSettings = getMediaSettings();

      await getUserMedia({
        audio: {
          echoCancellation: true,
          noiseSuppression: true,
        },
        video: {
          width: {
            max: 1920,
            ideal: 1280,
          },
          height: {
            max: 1080,
            ideal: 720,
          },
        },
      });

      doPreMediaSetup();

      // we're using the default RemoteMediaManagerConfig
      const mediaOptions = {
        localStreams: {
          microphone: localMedia.microphoneStream,
          camera: localMedia.cameraStream,
          // screenShare: {
          //   audio: localMedia.screenShare?.audio,
          //   video: localMedia.screenShare?.video,
          // },
        },
        audioEnabled: true,
        videoEnabled: true,
        shareAudioEnabled: true,
        shareVideoEnabled: true,
        allowMediaInLobby: true,
        bundlePolicy: 'max-bundle',
        receiveShare: true,
        sendShare: true,
      };
      await meeting.joinWithMedia({ joinOptions, mediaOptions });

      if (
        meeting?.recording?.state !== 'recording' &&
        meeting?.recording?.state !== 'paused'
      ) {
        handleStartRecording();
      }

      if (!networkDeactivated) {
        updateBatchClassStatus(
          apiMeetingId,
          'inProgress',
          firebase.firestore.FieldValue.serverTimestamp(),
          firebase.firestore.FieldValue.serverTimestamp()
        );
      }
      doPostMediaSetup();

      // }

      // >>>>>>>>>

      // enableMeetingDependentButtons(true);

      // For meeting controls button onclick handlers
      window.meeting = meeting;
      setAlreadyJoined(true);
      // updateMeetingInfoSection(meeting);

      meeting.members.on('members:update', (res) => {
        console.log('member update', meeting, res);
        if (meeting?.meetingState === 'TERMINATING') {
          handleMeetingEnd();
        }
        setAllRemoteVideos(
          meeting?.members?.receiveSlotManager?.allocatedSlots['VIDEO-MAIN']
        );
        let membersInMeet = Object.values(res?.full)?.filter((mem) => {
          if (mem.isInMeeting && !mem?.isSelf) {
            return mem;
          }
        });
        let getSelfMember = Object.values(res?.full)?.filter((mem) => {
          if (mem?.isSelf) {
            setIsMuted(mem?.isAudioMuted);
            return mem;
          }
        });

        if (getSelfMember[0]) setSelfMemeber(getSelfMember[0]);

        /* This set timeout creates a delay between stream update and member update,
        when presenter on/off his media multiple time then student side media of presenter is not updating
        */
        setTimeout(() => {
          setMembersInMeet(membersInMeet);
        }, 1000);

        let lobyUsers = Object.values(res?.full)
          ?.filter((mem) => mem.isInLobby)
          ?.map((lobyMem) => lobyMem?.id);

        if (lobyUsers?.length > 0) {
          meeting?.admit(lobyUsers);
        }
        console?.log(res, meeting, membersInMeet, 'allVideoPanes');
      });

      viewParticipants();

      meeting.on('meeting:stoppedSharingRemote', () => {});

      // meeting.on('meeting:self:mutedByOthers', () => {
      //   handleAudioButton();
      // });

      // meeting.on('meeting:self:unmutedByOthers', () => {
      //   handleAudioButton();
      // });

      // eventsList.innerText = '';
      meeting.on('all', (payload) => {
        updatePublishedEvents(payload);
      });
      document.querySelector('#loading-indicator').style.display = 'none';

      // createBreakoutOperations();
    } catch (err) {
      console.error(
        `failed to join a meeting (withMedia=${withMedia} withDevice=${withDevice}): `,
        err
      );
      await stopUserMedia();
      notify('Failed to join meet', true);

      setTimeout(() => {
        navigate('/admin/session-managemnt', {
          state: {
            triggerReload: true,
          },
        });
      }, 2000);
      document.querySelector('#loading-indicator').style.display = 'none';
      // closeMeeting();

      // meetingsJoinMultistreamElm.disabled = false;
    }
  }

  async function publishScreenShare(screenShare) {
    if (!screenShare || !screenShare.video) {
      console.log('Screen share stream not available!');
      throw new Error('screen share stream not available');
    }

    try {
      await meeting.remoteMediaManager.setLayout('ScreenShareView');

      await meeting.updateMedia({
        shareEnabled: true,
        sendShare: true,
        receiveShare: true,
      });

      // Publish the screen share streams
      await meeting.publishStreams({
        screenShare: {
          video: screenShare.video,
          audio: screenShare.audio,
        },
      });
      setIsScreenSharing(true);
    } catch (error) {
      console.error('Error starting screen share:', error);
      throw error;
    }
  }

  async function startScreenShare() {
    try {
      const constraints = {
        video: {
          displaySurface: 'monitor',
          frameRate: { ideal: 30, max: 60 },
          width: { ideal: 1920, max: 1920 },
          height: { ideal: 1080, max: 1080 },
        },
        audio: true,
      };

      const [localShareVideoStream, localShareAudioStream] =
        await webex.meetings.mediaHelpers.createDisplayStreamWithAudio();
      unpublishScreenShare(constraints);

      setLocalMedia({
        ...localMedia,
        screenShare: {
          video: localShareVideoStream,
          audio: localShareAudioStream,
        },
      });
      await publishScreenShare({
        video: localShareVideoStream,
        audio: localShareAudioStream,
      });
      console.log('shared');
    } catch (error) {
      console.error(error);
    }
  }

  async function unpublishScreenShare() {
    try {
      if (meeting.closeRemoteStreams) {
        await meeting.closeRemoteStreams();
      }

      await meeting?.member?.setIsContentSharing(false);

      const streamsToUnpublish = [];
      if (localMedia.screenShare.audio) {
        streamsToUnpublish.push(localMedia.screenShare.audio);
      }
      if (localMedia.screenShare.video) {
        streamsToUnpublish.push(localMedia.screenShare.video);
      }

      if (streamsToUnpublish.length) {
        await meeting.unpublishStreams(streamsToUnpublish);
      }
      if (localMedia.screenShare.audio) {
        localMedia.screenShare.audio?.stop();
      }
      if (localMedia.screenShare.video) {
        localMedia.screenShare.video?.stop();
      }
      if (isScreenSharing) {
        await meeting?.remoteMediaManager?.setLayout('AllEqual');
      }

      console.log(
        'MeetingControls#unpublishScreenShare() :: unpublished share stream!'
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async function stopScreenShare() {
    try {
      if (meeting.closeRemoteStreams) {
        await meeting.closeRemoteStreams();
      }

      await unpublishScreenShare();

      await meeting.updateMedia({
        shareEnabled: false,
        sendShare: false,
        receiveShare: true,
        screenShare: null,
      });

      setIsScreenSharing(false);
      setScreenShareStream(null);
      setLocalMedia({
        ...localMedia,
        screenShare: {
          video: undefined,
          audio: undefined,
        },
      });

      console.log('Successfully stopped sharing!');
    } catch (error) {
      console.error('Error stopping screen share:', error);
      throw error;
    }
  }

  function toggleScreenShare() {
    try {
      if (isScreenSharing) {
        stopScreenShare();
      } else {
        startScreenShare();
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function toggleSendVideo() {
    try {
      if (localMedia?.cameraStream) {
        const newMuteValue = !localMedia?.cameraStream?.userMuted;

        localMedia?.cameraStream?.setUserMuted(newMuteValue);
        setMuteVideo(newMuteValue);
        // localVideoRef.current.srcObject = localMedia.cameraStream.outputStream;

        // if (!newMuteValue) {
        //   await stopCamera();
        // } else {
        //   loadCamera();
        // }
        console.log(
          `MeetingControls#toggleSendVideo() :: Successfully ${
            newMuteValue ? 'muted' : 'unmuted'
          } video!`,
          newMuteValue
        );

        // if (isBrb) {
        //   toggleBrb({ unmuteVideo: true });
        // }
      }
    } catch (error) {
      console.log(error);
    }
  }

  const getBatchClassStatus = async (webExMeetingId) => {
    try {
      const batchClassesRef = db.collection('BatchClasses');
      const querySnapshot = await batchClassesRef
        .where('webExMeetingId', '==', webExMeetingId)
        .get();

      if (querySnapshot.empty) {
        console.log('No matching documents found.');
        return;
      }

      const batchClasses = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setMeetingActualStartTime(batchClasses[0]?.startedOn?.seconds);
    } catch (error) {
      console.error('Error fetching document: ', error);
    }
  };

  const updateBatchClassStatus = async (
    webExMeetingId,
    newStatus,
    startedOn,
    lastStartedOn
  ) => {
    try {
      const batchClassesRef = db.collection('BatchClasses');
      const querySnapshot = await batchClassesRef
        .where('webExMeetingId', '==', webExMeetingId)
        .get();

      if (querySnapshot.empty) {
        console.log('No matching documents found.');
        return;
      }

      querySnapshot.forEach(async (docSnap) => {
        const docRef = batchClassesRef.doc(docSnap.id);
        const updateData = { status: newStatus };

        if (startedOn) updateData.startedOn = startedOn;
        if (lastStartedOn) updateData.lastStartedOn = lastStartedOn;

        await docRef.update(updateData);
        if (!networkDeactivated) {
          await getBatchClassStatus(apiMeetingId);
        }
      });
    } catch (error) {
      console.error('Error updating document: ', error);
    }
  };

  async function toggleMuteAll() {
    const mutedEnabled = true; // true = mute all
    const disallowUnmuteEnabled = true; // participants can't unmute themselves
    const muteOnEntryEnabled = true; // mute new participants on entry
    try {
      if (muteAll) {
        setMuteAll(false);
        await meeting.setMuteAll(
          mutedEnabled,
          disallowUnmuteEnabled,
          muteOnEntryEnabled
        );
        console.log(
          'MeetingControls#toggleMuteAll() :: unmuting all participants'
        );
      } else {
        setMuteAll(true);
        await meeting.setMuteAll(false, false, false);
      }
      console.log('All participants muted successfully.');
    } catch (error) {
      console.error('Failed to mute all:', error);
    }
  }

  function toggleSendAudio() {
    try {
      if (localMedia?.microphoneStream) {
        const newMuteValue = !localMedia?.microphoneStream?.userMuted;

        localMedia?.microphoneStream?.setUserMuted(newMuteValue);

        setIsMuted(newMuteValue);

        // if (isBrb) {
        //   toggleBrb({ unmuteAudio: true });
        // }
      }
    } catch (error) {
      console.log(error);
    }
  }

  const leaveMeeting = async (isRefresh = false) => {
    try {
      if (!meeting) return;

      // if (!networkDeactivated) {
      // Stop local media tracks in parallel
      if (localMedia) {
        localMedia.camera?.getTracks().forEach((track) => track.stop());
        localMedia.microphone?.getTracks().forEach((track) => track.stop());
      }

      // Stop screen share if active
      const stopScreenPromise =
        isScreenSharing && screenShareStream
          ? stopScreenShare()
          : Promise.resolve();

      // Execute other async cleanup in parallel
      await Promise.all([
        stopScreenPromise,
        meeting.leave({
          resourceId: '',
          clientEventLeaveReason: 'one-to-one',
          reason: 'user-initiated',
        }),
        stopUserMedia(),
      ]);
      await webex.meetings.unregister();

      webex = null;
      if (isRefresh) {
        navigate('/admin/session-managemnt', {
          state: {
            triggerReload: true,
          },
        });
      } else {
        navigate('/admin/session-managemnt');
      }
      // }
    } catch (error) {
      console.error('Error leaving meeting:', error);
    }
  };

  const endMeeting = async () => {
    try {
      if (!meeting || networkDeactivated) return;

      // Stop local media tracks
      if (localMedia) {
        localMedia.camera?.getTracks().forEach((track) => track.stop());
        localMedia.microphone?.getTracks().forEach((track) => track.stop());
      }

      // Stop screen sharing if active
      if (isScreenSharing && screenShareStream) {
        await stopScreenShare();
      }

      // Call SDK method to end the meeting (must be host)
      await meeting.endMeetingForAll();

      await stopUserMedia();
      navigate('/admin/session-managemnt');
    } catch (error) {
      console.error('Error ending the meeting:', error);
    }
  };

  const handleMeetingEnd = async () => {
    try {
      console.log('meeting ended Leaving....');
      if (!meeting || networkDeactivated) return;

      // Stop camera and mic tracks immediately
      if (localMedia) {
        localMedia.camera?.getTracks().forEach((track) => track.stop());
        localMedia.microphone?.getTracks().forEach((track) => track.stop());
      }

      // Conditionally stop screen share
      const stopScreenPromise =
        isScreenSharing && screenShareStream
          ? stopScreenShare()
          : Promise.resolve();

      // Run cleanup tasks in parallel
      await Promise.all([stopScreenPromise, stopUserMedia()]);

      // Navigate with state
      navigate('/admin/session-managemnt');
    } catch (error) {
      console.error('Error leaving meeting:', error);
    }
  };

  useEffect(() => {
    if (meeting) {
      setupMultistreamEventListeners();

      if (isOnline && !alreadyJoined) {
        joinMeeting({ withMedia: true });
      }
    }

    if (!meeting) {
      // await stopUserMedia();
      setTimeout(() => {
        navigate('/admin/session-managemnt');
      }, 1000);
    }
    // window.addEventListener('popstate', leaveMeeting);
    window.addEventListener('beforeunload', leaveMeeting);
    return () => {
      // window.removeEventListener('popstate', leaveMeeting);
      window.removeEventListener('beforeunload', leaveMeeting);
      setupMultistreamEventListeners();
    };
  }, [meeting]);

  useBeforeUnload();

  useEffect(() => {
    window.addEventListener('popstate', leaveMeeting);
    return () => window.removeEventListener('popstate', leaveMeeting);
  });

  useEffect(() => {
    const handlePopState = async (event) => {
      await leaveMeeting(true);
    };
    window.addEventListener('popstate', handlePopState);
    window.history.pushState(
      { meeting: true },
      document.title,
      window.location.href
    );

    return () => {
      window.removeEventListener('popstate', handlePopState);
      if (window.history.state && window.history.state.meeting) {
        console.log('checking running');
        window.history.back();
      }
    };
  }, []);

  // console.log(
  //   membersInMeet?.filter((member) => member?.isSelf && member?.isModerator),
  //   'memberssssss'
  // );

  useEffect(() => {
    if (!isOnline) {
      setNetworkDeactivated(true);
    }
    if (networkDeactivated && isOnline) {
      setNetworkDeactivated(false);
    }
  }, [isOnline]);
  console.log(
    isOnline,
    networkDeactivated,
    alreadyJoined,
    'isOnline,networkDeactivated'
  );

  // useLeaveOnUnload(meeting);

  return (
    <>
      <NotificationAlert ref={notifi} />
      {networkDeactivated ? (
        <div className='meeting-network-loading-container'>
          <img
            src={require('../../../assets/img//loading.gif')}
            width='100px'
            alt='loader-img'
          />
          <p>Network Disconnected!.Rejoining...</p>
        </div>
      ) : (
        <div className='video-call-container'>
          <div className='top-bar'>
            <div className='controls'>
              {meetingActualStartTime > 0 && (
                <MeetingDuration startTime={meetingActualStartTime * 1000} />
              )}

              <div className='controls-recording-container'>
                {
                  // isRecording ? (
                  //   <div className='controls-play-pause-recording-container'>
                  //     <button
                  //       className={`icon-buttons`}
                  //       onClick={togglrRecordingPlayPause}
                  //     >
                  //       {pauseRecording ? (
                  //         <PlayCircleFilledIcon />
                  //       ) : (
                  //         <PauseCircleIcon />
                  //       )}
                  //     </button>
                  //     <button
                  //       className={`icon-buttons`}
                  //       onClick={handleStopRecording}
                  //     >
                  //       <StopCircleIcon />
                  //     </button>
                  //   </div>
                  // ) :

                  meeting?.recording?.state === 'recording' ||
                  meeting?.recording?.state === 'paused' ? (
                    <p
                      style={{
                        display: 'flex',
                        gap: '4px',
                        alignItems: 'center',
                        fontSize: '14px',
                      }}
                    >
                      <AdjustIcon
                        sx={{
                          fontSize: '1.25rem',
                          color:
                            meeting?.recording?.state === 'recording'
                              ? 'green'
                              : 'yellow',
                        }}
                      />
                      {meeting?.recording?.state === 'recording'
                        ? 'Recording'
                        : 'Recording Paused'}
                    </p>
                  ) : (
                    <button
                      className={`controls-recording-start`}
                      onClick={handleStartRecording}
                    >
                      Start Recording
                    </button>
                  )
                }
              </div>

              <div className='meet-screen-meeting-name-container'>
                <p>{ongoingclassName}</p>
              </div>

              <button
                className={`icon-buttons ${isScreenSharing ? 'active' : ''}`}
                onClick={toggleScreenShare}
              >
                {isScreenSharing ? (
                  <StopScreenShareIcon />
                ) : (
                  <ScreenShareIcon />
                )}
              </button>
              <button
                className={`icon-buttons ${isMuted ? 'active' : ''}`}
                onClick={toggleSendAudio}
              >
                {isMuted ? <MicOffIcon /> : <MicIcon />}
              </button>
              <button
                className={`icon-buttons ${muteVideo ? 'active' : ''}`}
                onClick={toggleSendVideo}
              >
                {muteVideo ? <VideocamOffIcon /> : <VideocamIcon />}
              </button>
              <button className={`mute-all-button`} onClick={toggleMuteAll}>
                {muteAll ? (
                  <>
                    <MicOffIcon /> Mute All
                  </>
                ) : (
                  <>
                    <MicIcon /> Unmute All
                  </>
                )}
              </button>
              <button className='leave-button' onClick={leaveMeeting}>
                <ExitToAppIcon /> Leave
              </button>
              {console.log(
                process.env?.REACT_APP_INTEGRATION_ADMIN_EMAIL,
                'ererererer',
                membersInMeet?.some(
                  (mem) =>
                    mem?.name == process.env.REACT_APP_INTEGRATION_ADMIN_EMAIL
                )
              )}
              {
                // (selfMemeber?.name ===
                //   process.env.REACT_APP_INTEGRATION_ADMIN_EMAIL ||
                //   !membersInMeet?.some(
                //     (mem) =>
                //       mem?.name == process.env.REACT_APP_INTEGRATION_ADMIN_EMAIL
                //   ))

                isModerator && (
                  <button className='leave-button' onClick={endMeeting}>
                    <ExitToAppIcon /> End Meet
                  </button>
                )
              }
            </div>
          </div>

          <div className='grid-container'>
            {!startedSharingRemote && (
              <div
                className={`video-item ${isScreenSharing ? 'local-video' : ''}`}
              >
                {muteVideo ? (
                  <div className='participant-icon-container'>
                    <AccountCircleIcon style={{ fontSize: '10rem' }} />
                  </div>
                ) : (
                  <>
                    {localMedia.cameraStream && (
                      <MeetingVideoComponent
                        stream={localMedia.cameraStream.outputStream}
                      />
                    )}
                  </>
                )}
                {/* <audio
                  ref={localAudioRef}
                  id='local-audio'
                  autoPlay
                  muted
                ></audio> */}
                <div className='participant-name'>
                  You {isMuted && '(Muted)'}
                </div>
              </div>
            )}

            {!startedSharingRemote &&
              membersInMeet &&
              membersInMeet?.length > 0 &&
              membersInMeet?.map((member, i) => {
                let stream = setRemoteStream(member.id)?.stream;
                console.log(stream);
                return (
                  <div key={member?.id} className='video-item active-speaker'>
                    {member?.isHandRaised && (
                      <PanToolIcon
                        className='rise-hand-yellow'
                        style={{ color: 'yellow' }}
                      />
                    )}
                    <MeetingVideoComponent stream={stream} />

                    <div className='participant-name'>
                      {member?.name}

                      {member.isAudioMuted ? (
                        <MicOffIcon
                          onClick={() => {
                            muteParticipant(member.id, false);
                          }}
                        />
                      ) : (
                        <></>
                      )}
                    </div>

                    {!member.isAudioMuted && (
                      <button
                        onClick={() => muteParticipant(member.id, true)}
                        className='mute-participant'
                      >
                        Mute Participant
                      </button>
                    )}
                  </div>
                );
              })}
            {console.log(
              startedSharingRemote,
              screenShareStream,
              'screenShareStreamscreenShareStreamscreenShareStream'
            )}
            {startedSharingRemote && screenShareStream && (
              <div className='video-item screen-share'>
                <div>
                  <MeetingVideoComponent noMirror stream={screenShareStream} />
                  {console.log(
                    membersInMeet,
                    'membersInMeetmembersInMeetmembersInMeetmembersInMeet'
                  )}
                  {membersInMeet
                    .filter((mem) => mem.isContentSharing)
                    .map((mem) => (
                      <div
                        key={mem?.id}
                        className='video-item active-speaker'
                        style={{
                          position: 'absolute',
                          top: '2px',
                          right: '2px',
                        }}
                      >
                        {mem?.isHandRaised && (
                          <PanToolIcon
                            className='rise-hand-yellow'
                            style={{ color: 'yellow' }}
                          />
                        )}
                        <MeetingVideoComponent
                          stream={setRemoteStream(mem.id)?.stream}
                        />

                        <div className='participant-name'>
                          {/* {mem?.name} */}
                          {mem.isAudioMuted ? <MicOffIcon /> : ''}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            )}

            {remoteAudios?.length > 0 &&
              remoteAudios?.map((audio, i) => (
                <React.Fragment key={i}>
                  {audio?.stream && <AudioComponent stream={audio?.stream} />}
                </React.Fragment>
              ))}
          </div>
        </div>
      )}
    </>
  );
};

export default MeetingScreen;
